import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Element } from 'react-scroll';
import { get as _get } from 'lodash';
import { setTopSpotsScrollPosition } from '../../../actions/animations';
import { fetchLocationView } from '../../../actions/locationView';
import { fetchTopSpots } from '../../../actions/topSpots';
import { navigatedToPage } from '../../../actions/segmentEvents';
import scrollPositionPropType from '../../../propTypes/scrollPosition';
import locationViewPropType from '../../../propTypes/locationView';
import topSpotsPropType from '../../../propTypes/topSpots';
import unitsPropType from '../../../propTypes/units';
import { getTopSpotsScrollPosition } from '../../../selectors/animations';
import { getLocationView, getUnits } from '../../../selectors/locationView';
import getTopSpots from '../../../selectors/topSpots';
import { getPremiumStatus } from '../../../selectors/user';
import MotionScrollWrapper from '../../../components/MotionScrollWrapper';
import Hero from '../../../components/Hero';
import TravelSummary from '../../../components/TravelSummary';
import ChildGrid from '../../../components/ChildGrid';
import RelatedArticles from '../../../components/RelatedArticles';
import TopSpots from '../../../components/TopSpots';
import TravelMap from '../../../components/TravelMap';
import ViewForecast from '../../../components/ViewForecast';
import MetaTags from '../../../components/MetaTags';
import { travelPaths } from '../../../utils/urls/travelPath';

class TravelLocation extends Component {
  componentDidMount() {
    const {
      doNavigatedToPage,
      match: {
        params: { geonameId },
      },
    } = this.props;
    doNavigatedToPage(`${_get(this.props, 'locationView.taxonomy.name', null)} Beaches`, {
      category: 'beaches',
      geonameId,
      geonameName: _get(this.props, 'locationView.taxonomy.name', null),
    });
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    /* fetch location view on client route change */
    const {
      doFetchLocationView,
      doFetchTopSpots,
      match: {
        params: { geonameId },
      },
    } = this.props;
    if (geonameId !== nextProps.match.params.geonameId) {
      doFetchLocationView(nextProps.match.params.geonameId);
      doFetchTopSpots(nextProps.match.params.geonameId);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      doNavigatedToPage,
      match: {
        params: { geonameId },
      },
    } = this.props;
    if (
      _get(prevProps, 'locationView.taxonomy.name', null) !==
      _get(this.props, 'locationView.taxonomy.name', null)
    ) {
      doNavigatedToPage(`${_get(this.props, 'locationView.taxonomy.name', null)} Beaches`, {
        category: 'beaches',
        geonameId,
        geonameName: _get(this.props, 'locationView.taxonomy.name', null),
      });
    }
  }

  render() {
    const {
      locationView,
      topSpots,
      units,
      doSetTopSpotsPosition,
      topSpotsScrollPosition,
      isPremium,
    } = this.props;
    const { taxonomy, url, children, travelContent, breadCrumbs } = locationView;

    const name = _get(locationView, 'taxonomy.name', '');
    const title = `Best Beaches in ${name} - Expert Guide to Traveling & Surfing in ${name} - Surfline`;
    const description = `Know Before You Go. Get the best ${name} travel and weather info along with live HD ${name} cams. Access to the world's best surf forecast team at Surfline.`;
    const urlPath = `${travelPaths.base}${url}`;

    /* Temp fix for travel jpgs routing here */
    if (!travelContent && !breadCrumbs) return null;

    return (
      <div>
        <MetaTags title={title} description={description} urlPath={urlPath} />
        <Hero travelContent={travelContent} taxonomy={taxonomy} breadCrumbs={breadCrumbs} />
        <Element name="sl-travel-anchor" className="sl-travel-anchor" />
        {travelContent && travelContent.media.large ? (
          <TravelSummary travelContent={travelContent} />
        ) : null}
        {!isPremium ? <ViewForecast taxonomy={taxonomy} /> : null}
        {children && children.length ? (
          <ChildGrid taxonomy={taxonomy} geoChildren={children} />
        ) : null}
        <MotionScrollWrapper scrollPosition={topSpotsScrollPosition}>
          <TopSpots
            taxonomy={taxonomy}
            topSpots={topSpots}
            units={units}
            doSetTopSpotsPosition={pos => doSetTopSpotsPosition(pos)}
            isPremium={isPremium}
          />
        </MotionScrollWrapper>
        <TravelMap taxonomy={taxonomy} />
        {travelContent && travelContent.relatedPosts.length ? (
          <RelatedArticles
            relatedArticles={travelContent.relatedPosts.filter(article => !!article)}
          />
        ) : null}
      </div>
    );
  }
}

TravelLocation.propTypes = {
  locationView: locationViewPropType,
  units: unitsPropType.isRequired,
  doSetTopSpotsPosition: PropTypes.func.isRequired,
  topSpots: topSpotsPropType.isRequired,
  topSpotsScrollPosition: scrollPositionPropType.isRequired,
  isPremium: PropTypes.bool.isRequired,
  doFetchLocationView: PropTypes.func.isRequired,
  doFetchTopSpots: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      geonameId: PropTypes.string,
    }),
  }).isRequired,
  doNavigatedToPage: PropTypes.func.isRequired,
};

TravelLocation.defaultProps = {
  locationView: {
    taxonomy: null,
    url: null,
    associated: null,
    boundingBox: null,
  },
};

TravelLocation.fetch = [
  ({ geonameId }, { cookies }) => fetchLocationView(geonameId, cookies),
  ({ geonameId }, { cookies }) => fetchTopSpots(geonameId, cookies),
];

export default connect(
  state => ({
    locationView: getLocationView(state),
    topSpots: getTopSpots(state),
    units: getUnits(state),
    topSpotsScrollPosition: getTopSpotsScrollPosition(state),
    isPremium: getPremiumStatus(state),
  }),
  dispatch => ({
    doSetTopSpotsPosition: scrollPosition => dispatch(setTopSpotsScrollPosition(scrollPosition)),
    doFetchLocationView: geonameId => dispatch(fetchLocationView(geonameId)),
    doFetchTopSpots: geonameId => dispatch(fetchTopSpots(geonameId)),
    doNavigatedToPage: (name, properties) => dispatch(navigatedToPage(name, properties)),
  })
)(TravelLocation);
